import filterUtility from './filter.utility.js'

const QUERY = Object.freeze({
  search: 'q',
  status: 'status',
  priority: 'priority',
  category: 'category',
  assignee: 'assignee',
  property: 'property',
  tenant: 'tenant',
  dueDateFrom: 'dueFrom',
  dueDateTo: 'dueTo',
  createdAtFrom: 'createdFrom',
  createdAtTo: 'createdTo',
  completionStatus: 'completion',
})

function readScalar(raw) {
  if (raw == null || raw === '') return null
  return String(raw)
}

function readIds(raw) {
  if (raw == null || raw === '') return []
  const parts = (Array.isArray(raw) ? raw : [raw]).flatMap((value) => String(value).split(','))
  return parts
    .map((id) => id.trim())
    .filter(Boolean)
    .map((id) => ({ id, name: '' }))
}

function writeIds(ids) {
  const values = filterUtility.pickerIds(ids)
  return values.length ? values.join(',') : null
}

function read(query = {}) {
  return {
    search: readScalar(query[QUERY.search]) ?? '',
    status: readScalar(query[QUERY.status]),
    priority: readScalar(query[QUERY.priority]),
    category: readScalar(query[QUERY.category]),
    assignee: readIds(query[QUERY.assignee]),
    property: readIds(query[QUERY.property]),
    tenant: readIds(query[QUERY.tenant]),
    dueDateFrom: readScalar(query[QUERY.dueDateFrom]) ?? '',
    dueDateTo: readScalar(query[QUERY.dueDateTo]) ?? '',
    createdAtFrom: readScalar(query[QUERY.createdAtFrom]) ?? '',
    createdAtTo: readScalar(query[QUERY.createdAtTo]) ?? '',
    completionStatus: readScalar(query[QUERY.completionStatus]),
  }
}

function has(query = {}) {
  return filterUtility.has(read(query))
}

function withFilters(query = {}, bag = {}) {
  const next = { ...query }

  for (const key of Object.values(QUERY)) {
    delete next[key]
  }

  if (bag.search) next[QUERY.search] = bag.search
  if (bag.status) next[QUERY.status] = bag.status
  if (bag.priority) next[QUERY.priority] = bag.priority
  if (bag.category) next[QUERY.category] = bag.category

  const assignee = writeIds(bag.assignee)
  if (assignee) next[QUERY.assignee] = assignee
  const property = writeIds(bag.property)
  if (property) next[QUERY.property] = property
  const tenant = writeIds(bag.tenant)
  if (tenant) next[QUERY.tenant] = tenant

  if (bag.dueDateFrom) next[QUERY.dueDateFrom] = bag.dueDateFrom
  if (bag.dueDateTo) next[QUERY.dueDateTo] = bag.dueDateTo
  if (bag.createdAtFrom) next[QUERY.createdAtFrom] = bag.createdAtFrom
  if (bag.createdAtTo) next[QUERY.createdAtTo] = bag.createdAtTo
  if (bag.completionStatus) next[QUERY.completionStatus] = bag.completionStatus

  return next
}

function sameQuery(a = {}, b = {}) {
  return filterUtility.same(read(a), read(b))
}

class TicketFilterQueryUtility {
  read(query) {
    return read(query)
  }

  has(query) {
    return has(query)
  }

  withFilters(query, bag) {
    return withFilters(query, bag)
  }

  sameQuery(a, b) {
    return sameQuery(a, b)
  }
}

export default new TicketFilterQueryUtility()
